/* eslint-disable */
import { MODULE_NAME } from '../constants';

/* WARNING: These selectors are deprecated.
 * Do not add any new selectors.
 */
export const all = state => state[MODULE_NAME];
export const user = state => state[MODULE_NAME].user;
